export default __webpack_public_path__ + "static/media/diners.b4829e4b.svg";